import { t } from "ttag";

import { ScreenLayout } from "@/app/components/layouts";
import { usePageTitle } from "@/shared/hooks";
import {
  DocumentCenterDoctorNotes,
  DocumentCenterHeader,
  DocumentCenterLabs,
  DocumentCenterMedicalRecords,
  DocumentCenterPrescriptions,
} from "./components";

export const DocumentCenterOverview = () => {
  usePageTitle(t`Document center`);

  // const hasActiveSubscription = usePortalUserStore(
  //   (state) => state.hasActiveSubscription,
  // );

  return (
    <ScreenLayout>
      <DocumentCenterHeader />

      {/* {hasActiveSubscription && <LevelsRxResources />} */}

      <section className="grid shrink-0 gap-4 lg:grid-cols-2">
        <DocumentCenterLabs />

        <DocumentCenterPrescriptions />

        <DocumentCenterDoctorNotes />

        <DocumentCenterMedicalRecords />
      </section>
    </ScreenLayout>
  );
};
